import React from 'react';

interface Props {
  size?: 'sm' | 'md';
  withIcon?: boolean;
  style?: React.CSSProperties;
  title?: string;
}

/**
 * Visual indicator that a recruiter is an Org Admin. Render conditionally — this
 * component does not check the flag itself.
 */
const OrgAdminBadge: React.FC<Props> = ({ size = 'sm', withIcon = true, style, title }) => {
  const fontSize = size === 'sm' ? '0.72em' : '0.85em';
  const padding = size === 'sm' ? '2px 8px' : '3px 10px';
  return (
    <span
      className="chip chip--accent"
      title={title || 'This user is an Org Admin and manages your organization on talixjobs.'}
      style={{
        fontSize,
        padding,
        fontWeight: 600,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        letterSpacing: 0.2,
        ...style,
      }}
    >
      {withIcon && (
        <span aria-hidden="true" style={{ display: 'inline-block', lineHeight: 1 }}>
          {/* Compact shield glyph; keeps weight without an icon font dep */}
          ◆
        </span>
      )}
      <span>Org Admin</span>
    </span>
  );
};

export default OrgAdminBadge;
